/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Member_Subscribed_TitleInputs */

const en_newsletter_member_subscribed_title = /** @type {(inputs: Newsletter_Member_Subscribed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're on the list`)
};

/**
* | output |
* | --- |
* | "You're on the list" |
*
* @param {Newsletter_Member_Subscribed_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_member_subscribed_title = /** @type {((inputs?: Newsletter_Member_Subscribed_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Member_Subscribed_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_member_subscribed_title(inputs)
});